import CredoraComingSoon from "../Components/Credora/Common/CredoraComingSoon";
import AccountingOverviewPage from "../Components/Credora/Accounting/AccountingOverviewPage";
import AccountingSettingsPage from "../Components/Credora/Accounting/AccountingSettingsPage";
import AccountsPayablePage from "../Components/Credora/Accounting/AccountsPayablePage";
import AccountsReceivablePage from "../Components/Credora/Accounting/AccountsReceivablePage";
import BalanceSheetPage from "../Components/Credora/Accounting/BalanceSheetPage";
import BankReconciliationPage from "../Components/Credora/Accounting/BankReconciliationPage";
import BudgetVsActualPage from "../Components/Credora/Accounting/BudgetVsActualPage";
import CashFlowPage from "../Components/Credora/Accounting/CashFlowPage";
import DepreciationPage from "../Components/Credora/Accounting/DepreciationPage";
import FixedAssetsPage from "../Components/Credora/Accounting/FixedAssetsPage";
import ChartOfAccountsPage from "../Components/Credora/Accounting/ChartOfAccountsPage";
import CostCentersPage from "../Components/Credora/Accounting/CostCentersPage";
import ExpenseCategoriesPage from "../Components/Credora/Accounting/ExpenseCategoriesPage";
import ExpensesPage from "../Components/Credora/Accounting/ExpensesPage";
import FinancialPeriodsPage from "../Components/Credora/Accounting/FinancialPeriodsPage";
import GeneralLedgerPage from "../Components/Credora/Accounting/GeneralLedgerPage";
import IncomeStatementPage from "../Components/Credora/Accounting/IncomeStatementPage";
import JournalEntriesPage from "../Components/Credora/Accounting/JournalEntriesPage";
import PayrollPage from "../Components/Credora/Accounting/PayrollPage";
import PettyCashPage from "../Components/Credora/Accounting/PettyCashPage";
import TaxVatPage from "../Components/Credora/Accounting/TaxVatPage";
import TrialBalancePage from "../Components/Credora/Accounting/TrialBalancePage";
import VendorsPage from "../Components/Credora/Accounting/VendorsPage";
import { ACCOUNTING_PLACEHOLDERS, ACCOUNTING_SECTION } from "../Components/Credora/Accounting/accountingPlaceholders";

const IMPLEMENTED_PAGES = {
  accounting: AccountingOverviewPage,
  "accounting/settings": AccountingSettingsPage,
  "accounting/financial-periods": FinancialPeriodsPage,
  "accounting/chart-of-accounts": ChartOfAccountsPage,
  "accounting/general-ledger": GeneralLedgerPage,
  "accounting/journal-entries": JournalEntriesPage,
  "accounting/expenses": ExpensesPage,
  "accounting/expense-categories": ExpenseCategoriesPage,
  "accounting/vendors": VendorsPage,
  "accounting/cost-centers": CostCentersPage,
  "accounting/accounts-payable": AccountsPayablePage,
  "accounting/accounts-receivable": AccountsReceivablePage,
  "accounting/bank-reconciliation": BankReconciliationPage,
  "accounting/petty-cash": PettyCashPage,
  "accounting/trial-balance": TrialBalancePage,
  "accounting/balance-sheet": BalanceSheetPage,
  "accounting/income-statement": IncomeStatementPage,
  "accounting/cash-flow": CashFlowPage,
  "accounting/budget-vs-actual": BudgetVsActualPage,
  "accounting/fixed-assets": FixedAssetsPage,
  "accounting/depreciation": DepreciationPage,
  "accounting/payroll": PayrollPage,
  "accounting/tax-vat": TaxVatPage,
};

const soon = (page) => (
  <CredoraComingSoon
    mainTitle={ACCOUNTING_SECTION}
    parent={ACCOUNTING_SECTION}
    title={page.title}
    description={page.description}
  />
);

/**
 * @param {(path: string) => string} p - credora path helper from credoraRouteRegistry
 */
export function buildAccountingRoutes(p) {
  return ACCOUNTING_PLACEHOLDERS.map((page) => {
    const Component = IMPLEMENTED_PAGES[page.path];
    return {
      path: p(`/credora/${page.path}/:layout`),
      element: Component ? <Component /> : soon(page),
    };
  });
}

/** Path keys for menu access / RBAC (no layout slug). */
export function accountingPathKeys() {
  return ACCOUNTING_PLACEHOLDERS.map((page) => page.path);
}
